import { render, staticRenderFns } from "./product-modal-cmp.vue?vue&type=template&id=2a4e98e4&scoped=true"
import script from "./product-modal-cmp.vue?vue&type=script&lang=js"
export * from "./product-modal-cmp.vue?vue&type=script&lang=js"
import style0 from "./product-modal-cmp.vue?vue&type=style&index=0&id=2a4e98e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e98e4",
  null
  
)

export default component.exports